<template>
  <container :class="[baseCss, disabled ? ['disabled', 'pointer-events-none'] : null]">
    <flex>
      <flex-col :span="multiple ? 10 : 12" sm24>
        <transfer-list
          list="left"
          @select="onSelect"
          :icon-empty="iconEmpty"
          :icon-empty-size="iconEmptySize"
          :icon-empty-color="iconEmptyColor"
          :icon-empty-color-lightness="iconEmptyColorLightness"
          :dense="dense"
          :footer-align="footerAlign"
          :list-height="listHeight"
          :ui-color="uiColor"
          :ui-color-lightness="uiColorLightness"
          :ui-bg-color="uiBgColor"
          :ui-bg-color-lightness="uiBgColorLightness"
          :header="headerLeft"
          :multiple="multiple"
          :icon-provider="iconProvider"
          :icon-right="iconRight"
          :class="[multiple ? null : 'mr-1']"
          :items="items.left">
          <template v-slot:footer-left>
            <slot name="footer-left" />
          </template>
        </transfer-list>
      </flex-col>
      <flex-col :span="4" sm24 :class="['select-none']" v-if="multiple">
        <card full-height :class="['sm:m-2', 'md:mx-2', 'md:my-0']">
          <card-text :class="[`${baseCss}-controls`, 'p-1']" padding-off>
            <btn
              block
              @click="moveTo('right')"
              :color="uiColor"
              :color-lightness="uiColorLightness"
              :bg-color="uiBgColor"
              :bg-color-lightness="uiBgColorLightness"
              :disabled="!enabledLeft"
              :icon-left="iconRight"
              :icon-provider="iconProvider"
              :size="buttonSize" />
            <divider :class="['my-1']" />
            <btn
              block
              @click="moveTo()"
              :color="uiColor"
              :color-lightness="uiColorLightness"
              :bg-color="uiBgColor"
              :bg-color-lightness="uiBgColorLightness"
              :disabled="!enabledRight"
              :icon-left="iconLeft"
              :icon-provider="iconProvider"
              :size="buttonSize" />
          </card-text>
        </card>
      </flex-col>
      <flex-col :span="multiple ? 10 : 12" sm24>
        <transfer-list
          list="right"
          @select="onSelect"
          :icon-empty="iconEmpty"
          :icon-empty-size="iconEmptySize"
          :icon-empty-color="iconEmptyColor"
          :icon-empty-color-lightness="iconEmptyColorLightness"
          :dense="dense"
          :footer-align="footerAlign"
          :list-height="listHeight"
          :ui-color="uiColor"
          :ui-color-lightness="uiColorLightness"
          :ui-bg-color="uiBgColor"
          :ui-bg-color-lightness="uiBgColorLightness"
          :header="headerRight"
          :multiple="multiple"
          :icon-provider="iconProvider"
          :icon-right="iconRight"
          :class="[multiple ? null : 'ml-1']"
          :items="items.right">
          <template v-slot:footer-right>
            <slot name="footer-right" />
          </template>
        </transfer-list>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'
import TransferList from './transfer-list'

export default {
  name: 'Transfer',
  components: {
    TransferList
  },
  mixins: [
    methods
  ],
  data () {
    return {
      items: {
        left: [],
        right: []
      },
      baseCss: this.componentBaseCss('transfer', [])
    }
  },
  computed: {
    enabledLeft () {
      return !!this.getSelectedListItems().length
    },
    enabledRight () {
      return !!this.getSelectedListItems('right').length
    }
  },
  props: {
    dense: {
      type: Boolean
    },
    appendItems: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean
    },
    iconEmpty: {
      type: String
    },
    buttonSize: {
      type: String,
      default: 'sm',
      validator: value => {
        return [
          'xs',
          'sm',
          'base',
          'lg',
          'xl'
        ].includes(value)
      }
    },
    iconLeft: {
      type: String,
      default: 'chevron-double-left'
    },
    iconRight: {
      type: String,
      default: 'chevron-double-right'
    },
    headerLeft: {
      type: String
    },
    headerRight: {
      type: String
    },
    iconProvider: {
      type: String,
      default: 'mdi'
    },
    left: {
      type: Array,
      default: () => {
        return []
      },
      required: true
    },
    right: {
      type: Array,
      default: () => {
        return []
      },
      required: true
    },
    uiBgColor: {
      type: String
    },
    uiBgColorLightness: {
      type: Number
    },
    uiColor: {
      type: String
    },
    iconEmptySize: {
      type: Number,
      default: 3.5
    },
    iconEmptyColor: {
      type: String,
      default: 'gray'
    },
    iconEmptyColorLightness: {
      type: Number,
      default: 400
    },
    uiColorLightness: {
      type: Number
    },
    listHeight: {
      type: String
    },
    footerAlign: {
      type: String
    },
    itemMovedHighlightColor: {
      type: String,
      default: 'yellow'
    },
    itemMovedHighlightColorLightness: {
      type: Number,
      default: 200
    }
  },
  watch: {
    left () {
      this.items.left = this.left
    },
    right () {
      this.items.right = this.right
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.items.left = this.left
      this.items.right = this.right
    },
    swap (list) {
      return list === 'left' ? 'right' : 'left'
    },
    onSelect ($event) {
      this.items[$event.list] = $event.items
      if (!$event.multiple) {
        this.moveTo(this.swap($event.list))
      }
    },
    getSelectedListItems (list = 'left') {
      return this.items[list].filter(item => item.selected)
    },
    moveTo (list = 'left') {
      const moveFromList = this.swap(list)
      const getSelectedListItems = this.getSelectedListItems(moveFromList)
      getSelectedListItems.forEach(item => {
        const itemIndex = this.items[this.swap(list)].findIndex(listItem => listItem.value === item.value)
        this.items[list][this.appendItems ? 'push' : 'unshift'](item)
        item.selected = false
        this.items[moveFromList].splice(itemIndex, 1)
      })
      this.$emit('input', this.items)
      this.$nextTick(() => {
        const newItem = this.$el.querySelector(`[data-list="${list}"] [role="listitem"]:${this.appendItems ? 'last' : 'first'}-child`)
        const bgCssClass = this.setBgColor('itemMovedHighlightColor', 'itemMovedHighlightColorLightness')
        newItem.classList.add(bgCssClass)
        newItem.focus()
        setTimeout(() => {
          newItem.classList.remove(bgCssClass)
        }, 1000)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/transfer/transfer.vue